import React from 'react';
import { LatestUpdateResponseType } from '../../../utils/Types';
import { Col, Row } from 'reactstrap';
import CloseIcon from '@mui/icons-material/Close';
import { formattedDateWithFormat } from '../../../utils/Util';

interface IUpdatesPreviewProps {
  updates: LatestUpdateResponseType[];
  handleRemove: (id: number | string) => void;
}

const UpdatesPreview: React.FunctionComponent<IUpdatesPreviewProps> = ({
  updates,
  handleRemove,
}) => {
  return (
    <div className="mt-3 me-3">
      {updates.length > 0 && (
        <Row className="d-flex flex-wrap">
          {updates.map((update) => (
            <Col
              lg={4}
              md={6}
              sm={6}
              xs={12}
              key={`latest-update-${update.latestUpdateId}`}
              className="mt-3 d-flex flex-column update-col"
            >
              <div className="clear-button">
                <CloseIcon
                  className="remove-icon"
                  onClick={() => {
                    handleRemove(update.latestUpdateId);
                  }}
                />
              </div>
              <div className="p-2 border rounded flex-grow-1 d-flex flex-column">
                <div className="flex-grow-1">
                  <p className="update-text mb-1">
                    {update.latestUpdateDescription}
                  </p>
                </div>
                <p className="subtitle m-0 mt-auto">
                  {formattedDateWithFormat(
                    update.createdOn,
                    'DD-MM-YYYY hh:mm A'
                  )}
                </p>
              </div>
            </Col>
          ))}
        </Row>
      )}
    </div>
  );
};

export default UpdatesPreview;
